import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const WeChatOverlay = lazy(
  () => import('./WeChatOverlay'/* webpackChunkName: 'WeChatOverlay' */),
);

function WeChatOverlayLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <WeChatOverlay {...props} />
    </GenericFallbackSuspense>
  );
}

export default WeChatOverlayLazyLoader;
